import { render, staticRenderFns } from "./organization-event-card.vue?vue&type=template&id=983e828c&scoped=true&"
import script from "./organization-event-card.vue?vue&type=script&lang=js&"
export * from "./organization-event-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983e828c",
  null
  
)

export default component.exports